import { axiosInstance } from 'utils';
import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import useError from 'hooks/useError';

type ClientCardSettings = any;

type Props = {
  children: ReactNode;
};

type ClientCardSettingsType = {
  autoRepaymentSkipOptionHidden: boolean;
};

type ClientCardSettingsContextType = {
  clientCardSettings: ClientCardSettingsType | undefined | null;
  fetchClientCardSettings: () => Promise<any | undefined>;
};

const ClientCardSettingsContext = createContext<ClientCardSettingsContextType>(
  {} as ClientCardSettingsContextType,
);

const useClientCardSettings = (): ClientCardSettingsContextType =>
  useContext(ClientCardSettingsContext);

const ClientCardSettingsProvider = ({ children }: Props): JSX.Element => {
  const [clientCardSettings, setClientCardSettings] = useState<
    ClientCardSettings | undefined | null
  >();
  const { showError } = useError();

  const fetchClientCardSettings =
    useCallback(async (): Promise<ClientCardSettings | void> => {
      try {
        const fetchedClientSettings = await axiosInstance.get(
          '/client/cards/settings',
        );
        setClientCardSettings(fetchedClientSettings.data);
        return fetchedClientSettings.data;
      } catch (e) {
        setClientCardSettings(null);
        showError(e);
        throw e;
      }
    }, []);

  const ClientCardSettingsContextValue = useMemo(
    () => ({
      clientCardSettings,
      fetchClientCardSettings,
    }),
    [clientCardSettings, fetchClientCardSettings],
  );

  return (
    <ClientCardSettingsContext.Provider value={ClientCardSettingsContextValue}>
      {children}
    </ClientCardSettingsContext.Provider>
  );
};

export { useClientCardSettings as default, ClientCardSettingsProvider };
